import React, { type ReactElement } from 'react'
import { type IButtonClassProps, type IButtonProps } from './Types'
import { createButtonClass } from '@/utils'

export default function Button ({
  testId,
  type,
  size,
  children,
  label,
  href,
  target,
  onClick,
  onSubmit,
  className,
  defaultClassName,
  disabled = false
}: IButtonProps): ReactElement {
  const _onClick = (): void => {
    if (typeof onClick === 'function') {
      onClick()
    }
    if (typeof onSubmit === 'function') {
      onSubmit()
    }
  }

  const cn = createButtonClass({
    defaultClassName,
    className,
    size,
    type
  })

  return (
    <>{
    href !== undefined
      ? <a
          href={href}
          target={target}
          className={cn}
          aria-disabled={disabled}>
            {children !== undefined ? children : label}
        </a>
      : <button
        className={cn}
        disabled={disabled}
        onClick={_onClick}
        >
          {children !== undefined ? children : label}
        </button>
      }</>
  )
}

export type {
  IButtonClassProps,
  IButtonProps
}
